import { API_URL } from "../../utils/contextHelpers";
import { api, apiPost, buildQuery, request } from "./core";

export const getTenantCompanyConfig = (tenant_id) => {
  const url = `${API_URL}tenantConfig/obtener?${buildQuery({ tenant_id })}`;
  return request(url, { method: "GET" });
};

export const getDestacadosConfig = api(
  "getDestacadosConfig",
  (tenant_id, canal) =>
    `${API_URL}tenantConfig/destacadosConfig?${buildQuery({ tenant_id, canal })}`
);

export const editarDestacadosConfig = apiPost(
  "editarDestacadosConfig",
  () => `${API_URL}tenantConfig/destacadosConfig/editar`,
  {
    body: ({ tenant_id, canal, limite, tipo, codigos }) =>
      buildQuery({ tenant_id, canal, limite, tipo, codigos }),
  }
);

export const getCategoriasConfig = api(
  "getCategoriasConfig",
  (tenant_id, canal) =>
    `${API_URL}tenantConfig/categoriasConfig?${buildQuery({ tenant_id, canal })}`
);

export const editarCategoriasConfig = apiPost(
  "editarCategoriasConfig",
  () => `${API_URL}tenantConfig/categoriasConfig/editar`,
  {
    body: ({ tenant_id, canal, limite, tipo, title, subtitle, ids }) =>
      buildQuery({ tenant_id, canal, limite, tipo, title, subtitle, ids }),
  }
);
